import React, { useState } from 'react';
import {
  Autocomplete, TextField, Chip, Box,
} from '@mui/material';
import { ISecurityProfileOption } from '../../state/securityProfiles';

interface ISecurityProfileFilterProps {
  securityProfiles: ISecurityProfileOption[];
  selectedSecurityProfileOptions: ISecurityProfileOption[];
  onSecurityProfileFiltersChanged: (securityProfiles: ISecurityProfileOption[]) => void;
}

const SecurityProfileFilter: React.FC<ISecurityProfileFilterProps> = (props: ISecurityProfileFilterProps) => {
  const { securityProfiles, selectedSecurityProfileOptions } = props;

  const handleProfileChange = (e: React.ChangeEvent<{}>, selectedSecurityProfiles: ISecurityProfileOption[]) => {
    const { onSecurityProfileFiltersChanged } = props;
    onSecurityProfileFiltersChanged(selectedSecurityProfiles);
  };

  return (
    <Box>
      <Autocomplete
        sx={{
          '.MuiAutocomplete-endAdornment': {
            top: '5px',
          },
        }}
        multiple
        options={securityProfiles}
        getOptionLabel={(option) => option.label}
        groupBy={(option) => option.group}
        disableCloseOnSelect
        isOptionEqualToValue={(a, b) => a._id === b._id}
        value={selectedSecurityProfileOptions}
        onChange={handleProfileChange}
        renderTags={(value: ISecurityProfileOption[], getTagProps) => value.map((option: ISecurityProfileOption, index: number) => (
          <Chip
            key={option._id}
            label={option.label}
            {...getTagProps({ index })}
          />
        ))}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label="Filter Security Profiles"
            placeholder="Type to filter"
          />
        )}
      />
    </Box>
  );
};

export default SecurityProfileFilter;
